<template>
  <nav>
    <v-row
      class="fill-height"
      align="center"
    >
      <v-col 
        v-if="isOwner"
        align="center"
        cols="12"
        sm="8"
        md="6"
        lg="4"
        offset-sm="2"
        offset-md="3"
        offset-lg="4"
      >
        <AlertMessages
          v-if="alertValue"
          :alert-type="alertType" 
          :alert-msg="alertMsg"
          @reset="alertValue = false"
        />

        <v-img
          src="../../assets/image3.png"
          width="100%"
          max-width="400px"
          class="mx-auto mb-10"
        />
        <p class="text-h5 font-weight-bold">
          {{ $t('confirmMsgTitle') }}
        </p>
        <p class="text-body-1">
          {{ $t('confirmMsgBodyDeleteSpace') }}
        </p>
        <v-form
          ref="form"
          v-model="valid"
        >
          <v-row>
            <v-col
              cols="12"
              sm="10"
              md="8"
              offset-sm="1"
              offset-md="2"
            >
              <v-text-field
                v-model="currentPassword"
                data-testid="password-current-input-delete-space"
                solo
                hide-details="auto"
                class="rounded-xxl text-body-2"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showPassword ? 'text' : 'password'"
                :placeholder="$t('deleteSpacePasswordPlaceholder')"
                :rules="passwordRules"
                @click:append="showPassword = !showPassword"
              />
            </v-col>
          </v-row>
        </v-form>
        <v-btn
          ref="cancel"
          data-testid="cancel-button"
          outlined
          elevation="0"
          class="rounded-xxl text-none mr-8 px-4 mt-10"
          @click="$router.go(-1)"
        >
          {{ $t('cancel') }}
        </v-btn>
        <v-btn
          data-testid="confirm-button"
          :loading="loading"
          color="error"
          class="rounded-xxl text-none px-4 mt-10"
          @click="confirmDeleteSpace()"
        >
          {{ $t('confirmBtn') }}
        </v-btn>
      </v-col>
    </v-row>
  </nav>
</template>
<script>
import { ruleRequired } from '../../rules/formRules.js';
import { deleteSpace } from '../../api/spaceApi';
import i18n from '../../plugins/i18n';
import { repeatedMethodsMixin } from '../../mixins/repeatedMethodsMixin'
import AlertMessages  from '../../components/AlertMessages'

export default {
    components: {
        AlertMessages
    },
    mixins: [repeatedMethodsMixin],
    data() {
        return{
            valid: true,
            showPassword: false,
            passwordRules: ruleRequired('labelPassword'),
            currentPassword:'',
            spaceId: window.$cookies.get('space_id'),
            alertMsg:'',
            alertType:'',
            alertValue:false,
            loading: false,
            isOwner: localStorage.space ? JSON.parse(localStorage.space).is_owner : false
        }
        
    },

    async created() {
      if (!this.isOwner) {
        this.$router.push({name: 'PageNotFound'})
      }
    },
    methods:{
        async confirmDeleteSpace(){
            this.$refs.form.validate()
            if(this.valid && this.isOwner){
                    this.loading = true
                    try {
                    let data = {
                            data: {
                            type: "spaces", 
                            id: this.spaceId,
                            attributes: {
                                password_current: this.currentPassword.trim(),
                                deleted_at: this.currentDate(),  
                            }
                        }
                        
                    };
                    const response = await deleteSpace(this.spaceId, data)
                    if(response.status == 200) {
                        window.$cookies.set("show_deleted_space_message", true, 0, null, process.env.VUE_APP_DOMAIN)
                        window.location.href = process.env.VUE_APP_PROTOCOL + "://id." + process.env.VUE_APP_DOMAIN + "/spaces"
                    }
                } catch (e) {
                    if(e.response){
                        if (e.response.status == 422 ){
                            this.alertValue = true
                            for(let i = 0; i < e.response.data.errors.length; i++){
                                if(e.response.data.errors[i].detail == 'The password current did not match!'){
                                     this.alertType = 'error'
                                     this.alertMsg = i18n.t('editUserErrorWrongCurrentPassword')
                                }else{
                                 this.alertType = 'error'
                                 this.alertMsg =  i18n.t('serverError')
                                }
                            }
                        }
                        else if (e.response.status == 404 ) {
                            this.alertValue = true
                            this.alertType = 'error'
                            this.alertMsg =  i18n.t('serverError')
                        }
                        else{
                            this.alertValue = true
                            this.alertType = 'error'
                            this.alertMsg =  i18n.t('serverError')
                        }
                    }
                }
                this.loading = false
            }
        }
    }
}
</script>
